import { useEffect, useState } from "react";
import { _RequestCreditInfo, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { MyEditor } from "../../../../theme/Component/MyEditor";
import { AtachDocument } from "../../../../theme/Component/AtachDocument";
import usePaginator from "../../../../theme/Component/usePaginator";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../contract/select/SelectMonths";
import { BasicButton } from "../../../../theme/Component/BasicButton";

interface Props {
    _IDAccount?: number
    _CreditID?: number;
    isModal?: boolean;
    cannotEdit?: boolean;
}

interface formData {
    Year: number;
    Month: number
}

export const RequestCreditInfo = ({ _IDAccount, _CreditID, isModal, cannotEdit }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_RequestCreditInfo);
    const paginador = usePaginator();

    const modal = useModal(``, MODAL_LG)
    const modalConfirm = useModal(`Eliminar Registro de Comunicación`, MODAL_SM)
    const modalMedias = useModal(`Documentos de la Solicitud`, MODAL_md)

    useEffect(() => {
        if (isModal && _IDAccount) {
            getLista();
        } else {
            getLista();
        }
    }, [_IDAccount, paginador.page])

    const getLista = () => {
        const props: any = {
            "IDAccount": _IDAccount,
            "IDCreditAccount": _CreditID,
            State: 1
        }

        const type = typeof (form.Month)

        if (form.Year) props.Year = form.Year
        if (typeof form.Month === "number" && !isNaN(form.Month)) props.Month = form.Month

        instance.getRequestCreditInfoRender(paginador.page, 15, props).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                resp.List.forEach(element => {
                    const data = element.DataBeanProperties;
                    data.AffiliateEntity = data.IDAccount ? `${data.NitAccount} - ${data.EntityNameAfiliado}` : "N/P"
                    data.EmployeeEntity = data.IDEmployee ? `${data.NitEmployee} - ${data.EntityNameAsesor}` : "N/P"
                });
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDRequestCreditInfo', visible: true, mask: MASK_NUMBER },
        { title: 'Numero de Caso', property: 'TicketNumber', visible: true },
        { title: 'Observaciones', property: 'Observation', visible: true },
        { title: 'Fecha del registro', property: 'Since', visible: true, mask: MASK_DATE },
        { title: 'Numero de Crédito', property: 'CreditNumber', visible: true },
        { title: 'Tipo de contacto', property: 'ContactTypeName', visible: true },
        { title: 'Afiliado', property: 'AffiliateEntity', visible: true },
        { title: 'Empleado', property: 'EmployeeEntity', visible: true },
    ]

    const create = () => {
        setBean({
            IDAccount: _IDAccount,
            IDCreditAccount: _CreditID,
            IDEmployee: _single.getAccountID(),
            State: 1,
        })
        setDocument([]);
        modal.open("Agregar registro de Comunicación");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate() && !cannotEdit, icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-folder-open-line', visible: _single.canEdit() && !cannotEdit, evento: () => { modal.setModal({ ...modal.modal, view: true, name: "Editar Registro de Comunicación" }); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete() && !cannotEdit, evento: () => { modalConfirm.open(); } },
            { titulo: 'Ver Documentos', icono: 'ri-check-line', visible: true, evento: () => { modalMedias.open(); } }, ,
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const editaItem = (obj: any) => {
        instance.updateRequestCreditInfo(obj).then(
            (resp) => {
                modal.close();
                modalConfirm.close();
                getLista();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    }

    const [document, setDocument] = useState<any[]>([]);

    useEffect(() => {
        if (bean.JSONMedia) {
            setDocument(JSON.parse(bean.JSONMedia))
        }
    }, [bean.JSONMedia])

    const [form, setForm] = useState<Partial<formData>>({});

    const componentStructure = () => {
        return (
            < div className="row" >
                <div className="col-md-4">
                    <YearSelector value={form.Year} onChange={(e) => { setForm({ ...form, Year: e }) }} tittle="Año" />
                </div>
                <div className="col-md-4">
                    <SelectMonths idSelector={form.Month} onChange={(e) => { setForm({ ...form, Month: e }) }} label="Mes" />
                </div>
                <div className="col-md-3">
                    <BasicButton useMargin eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
                </div>
                <div className="col-md-12">
                    <BasicTable
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        records={paginador}
                    />

                    <ModalConfirm modal={modalConfirm.modal} updateModal={modalConfirm.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>

                    <Modal modal={modalMedias.modal} updateModal={modalMedias.setModal} >
                        <AtachDocument _docList={document} onChange={() => { }} onlyView />
                    </Modal>

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }} >
                        <div className="row">
                            <div className="col-md-6">
                                <label>Tipo de Contacto</label>
                                <select className="form-select" value={bean.ContactType} onChange={(e) => {
                                    const value = e.target.value ? Number(e.target.value) : null;
                                    setBean({ ...bean, ContactType: value })
                                }}>
                                    <option value="">...</option>
                                    <option value="100">Telefono</option>
                                    <option value="101">Presencial</option>
                                    <option value="102">Correo</option>
                                    <option value="103">WhatsApp</option>

                                </select>
                            </div>
                            <div className="col-md-6">
                                <label>Numero de Caso</label>
                                <input type="text" className="form-control" value={bean.TicketNumber} onChange={(e) => { setBean({ ...bean, TicketNumber: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <AtachDocument _docList={document} onChange={(e) => { setDocument(e) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea onChange={(e) => { setBean({ ...bean, Observation: e }) }} value={bean.Observation} className="form-control" />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div >
        );
    }

    return isModal ? componentStructure() : (
        <BasicPage titulo="Registros de Comunicación">
            {componentStructure()}
        </BasicPage>
    );

}